import { render, staticRenderFns } from "./VList.vue?vue&type=template&id=b1d30dd4&lang=pug&functional=true"
import script from "./VList.vue?vue&type=script&lang=js"
export * from "./VList.vue?vue&type=script&lang=js"
import style0 from "./VList.vue?vue&type=style&index=0&id=b1d30dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports